import { PureComponent } from "react";

import { QESButton } from "@app/shared/qes-standards";
import { ColumnConfig, Waffles, wafflesKeyColumnName } from "@app/shared/waffles";

import { UserModelFromApi } from "@app/admin/user-administration/userModel";
import { FlyoutContextOutgoingProps, FlyoutFooter, withFlyoutContext } from "@app/shared/Flyouts";

interface AddRecipientPanelProps {
  licenseId: number;
  potentialUsers: UserModelFromApi[],
  onAddRecipients: (userIds: string[]) => void;
}

interface AddRecipientPanelState {
  selectedUserIds: string[];
  userTableData: UserTableData[];
}

interface UserTableData {
  [wafflesKeyColumnName]: string;
  name: string;
  userId: number;
}

const userColumnConfig: ColumnConfig = {
  name: {
    displayText: "Name",
    testId: "name",
  },
};

class WrappedAddRecipientPanelContent extends PureComponent<AddRecipientPanelProps & FlyoutContextOutgoingProps, AddRecipientPanelState> {
  constructor(props: AddRecipientPanelProps & FlyoutContextOutgoingProps) {
    super(props);
    this.state = {
      selectedUserIds: [],
      userTableData: [],
    };
  }

  public async componentDidMount() {
    if (!this.props.licenseId)
      return;

    this.setState({
      userTableData: this.createUserWafflesTable(this.props.potentialUsers)
    });
  }

  private createUserWafflesTable = (data: UserModelFromApi[]) => {
    return data.map((rec) => {
      /* eslint-disable sort-keys */
      return {
        key: rec.userId.toString(),
        userId: rec.userId,
        name: `${rec.firstName} ${rec.lastName}`
      };
      /* eslint-enable sort-keys */
    });
  }

  private handleCheckboxChange = (selectedKeys: string[]) => {
    this.setState({
      selectedUserIds: selectedKeys,
    });
  }

  private handleAddClick = () => {
    this.props.onAddRecipients(this.state.selectedUserIds);
    this.props.handleCloseFlyout();
  }

  public render() {
    return (
      <>
        <Waffles<UserTableData>
          columns={userColumnConfig}
          data={this.state.userTableData}
          showCheckboxes={true}
          selectedKeys={this.state.selectedUserIds}
          handleCheckboxChange={this.handleCheckboxChange}
          testId="add-recipient-panel-content__user-grid-waffles-table"
        />
        <div className="mt-3 mb-2">
          <FlyoutFooter
            submitButton={<QESButton
              qesTestId="add-recipient-panel-content__confirm"
              className="mr-2"
              qesType="primary"
              onClick={this.handleAddClick}
              disabled={this.state.selectedUserIds.length === 0}
            >
              Add
            </QESButton>}
          />
        </div>
      </>
    );
  }
}

const AddRecipientPanelContent = withFlyoutContext(WrappedAddRecipientPanelContent);
export default AddRecipientPanelContent;
